import { render, staticRenderFns } from "./myVideo.vue?vue&type=template&id=2756a224&scoped=true"
import script from "./myVideo.vue?vue&type=script&lang=js"
export * from "./myVideo.vue?vue&type=script&lang=js"
import style0 from "./myVideo.vue?vue&type=style&index=0&id=2756a224&prod&scoped=true&lang=css"
import style1 from "./myVideo.vue?vue&type=style&index=1&id=2756a224&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2756a224",
  null
  
)

export default component.exports